enum DictionaryTypes {
    sources = 'sources',
    levels = 'levels',
    themes = 'themes',
    numbersInKim = 'numbers-in-kim',
    tags = 'tags',
}

export default DictionaryTypes;